import React from "react";
import ImageService from "../atoms/ImageService";

const ServicesList = ({ services }) => {
  return services.map((item, index) => {
    return (
      <div className="col-md-6" key={index}>
        <div className="media">
          <ImageService />
          <div className="media-body">
            <h5 className="mt-0">{item.title}</h5>
            <p>{item.text}</p>
          </div>
        </div>
      </div>
    );
  });
};

export default ServicesList;
